import { call, delay, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadMaisEguLogsListFailed, loadMaisEguLogsListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';
import { LOADING_DELAY } from '../../System/constants';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadMaisEguLogsList(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL}/resources/mais-egu-logs`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadMaisEguLogsListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadMaisEguLogsListFailed());
      yield call(rejectActionPromise(action, data));
    }
    /*
    yield put(loadMaisEguLogsListSuccessful({
      data: [
        {
          id: 1,
          created_at: '2024-12-12',
          response_date: '2025-01-12',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 1,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
      ],
      meta: {
        limit: 10,
        page: 1,
        total: 5,
      },
    }));
    */
  } catch (e) {
    // yield put(loadMaisEguLogsListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
